var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2021(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,36.92c1.09,1.22,2.66,3,6.86,3,4.38,0,6.47-1.78,6.47-4,0-5.78-11.24-2-11.24-5.95,0-1.64,1.84-2.31,4.42-2.31,3.52,0,4.75,1.65,5.29,2.25L12.92,29c-.87-1.25-3-2.65-6.37-2.65s-6,1.12-6,3.86c0,5.24,11.23,1.81,11.23,5.71,0,2-2.71,2.56-4.69,2.56-3.87,0-5.11-1.62-5.85-2.61Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.12,26.68H27.55v7.6c0,2.95-1.89,4.29-5.06,4.29s-5.07-1.34-5.07-4.29v-7.6H15.86v7.6c0,4.65,3.63,5.61,6.63,5.61s6.63-1,6.63-5.61Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.54,39.57h1.55v-5.5h6c2.6,0,5-.73,5-3.69s-2.37-3.7-5-3.7H32.54Zm1.55-11.5h5.59c2.59,0,3.89.55,3.89,2.32s-1.3,2.3-3.89,2.3H34.09Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.28 39.57 58.97 39.57 58.97 38.19 48.84 38.19 48.84 33.56 57.12 33.56 57.12 32.18 48.84 32.18 48.84 28.07 58.75 28.07 58.75 26.68 47.28 26.68 47.28 39.57",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6,28.07h5.53c2.26,0,3.94.32,3.94,2.2s-1.68,2.21-3.94,2.21H62.6Zm-1.55,11.5H62.6v-5.7h5.08l4.14,5.7h1.94l-4.25-5.74c1.56-.07,4-.85,4-3.54,0-3.16-3-3.61-5.06-3.61H61.05Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.79,
    y: 26.68,
    width: 1.55,
    height: 12.89,
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.71 39.57 83.21 39.57 83.21 28.07 93.52 39.57 95.08 39.57 95.08 26.68 93.52 26.68 93.52 37.29 83.92 26.68 81.71 26.68 81.71 39.57",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.35 39.57 104.91 39.57 104.91 28.07 111.13 28.07 111.13 26.68 97.12 26.68 97.12 28.07 103.35 28.07 103.35 39.57",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 39.57 124.87 39.57 124.87 38.19 114.73 38.19 114.73 33.56 123.04 33.56 123.04 32.18 114.73 32.18 114.73 28.07 124.66 28.07 124.66 26.68 113.18 26.68 113.18 39.57",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.96 39.57 128.44 39.57 128.44 28.07 138.76 39.57 140.32 39.57 140.32 26.68 138.76 26.68 138.76 37.29 129.17 26.68 126.96 26.68 126.96 39.57",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.68,39.57h5.86c3.4,0,7.4-1.3,7.4-6.55,0-4.22-2.9-6.34-6.9-6.34h-6.36Zm1.56-11.5H150c2.62,0,5.29,1.12,5.29,4.89,0,5.07-4.26,5.23-5.53,5.23h-4.56Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.41 39.57 171.12 39.57 171.12 38.19 160.98 38.19 160.98 33.56 169.28 33.56 169.28 32.18 160.98 32.18 160.98 28.07 170.9 28.07 170.9 26.68 159.41 26.68 159.41 39.57",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.2 39.57 174.68 39.57 174.68 28.07 185.01 39.57 186.57 39.57 186.57 26.68 185.01 26.68 185.01 37.29 175.42 26.68 173.2 26.68 173.2 39.57",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,35.47a5.69,5.69,0,0,1-5.41,3c-3.89,0-5.89-2.19-5.89-5.14,0-3.68,2.08-5.68,5.77-5.68,2.45,0,4.46.88,5.36,3l1.35-.62c-1.16-2.63-4-3.69-6.74-3.69-4.34,0-7.33,2.36-7.33,6.79,0,3.73,2.35,6.73,7.36,6.73,3.13,0,5.53-1.07,6.9-3.74Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.67,
    y: 26.68,
    width: 1.55,
    height: 12.89,
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.35,34.84l3.44-6.94,3.47,6.94Zm-4.14,4.73H211l1.67-3.35h8.31l1.66,3.35h1.75l-6.59-12.89h-1.92Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.3,69.66h12c6.93,0,15.06-2.67,15.06-13.38,0-8.59-5.88-12.9-14-12.9H.3ZM3.49,46.2h9.8c5.35,0,10.81,2.28,10.81,10,0,10.33-8.71,10.66-11.33,10.66H3.49Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.44 69.66 56.28 69.66 56.28 66.84 35.6 66.84 35.6 57.41 52.52 57.41 52.52 54.59 35.6 54.59 35.6 46.2 55.85 46.2 55.85 43.38 32.44 43.38 32.44 69.66",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.37,64.24c2.23,2.49,5.42,6.08,14,6.08,8.93,0,13.19-3.66,13.19-8.07,0-11.79-22.92-4.18-22.92-12.15,0-3.32,3.74-4.7,9-4.7,7.17,0,9.7,3.36,10.78,4.6l2.31-1.89c-1.8-2.53-6.07-5.37-13-5.37-7.16,0-12.34,2.27-12.34,7.87,0,10.68,22.92,3.64,22.92,11.64,0,4.08-5.53,5.24-9.57,5.24-7.88,0-10.41-3.32-11.93-5.33Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.23,60l7.06-14.14,7,14.14Zm-8.42,9.65h3.55l3.43-6.84h16.95l3.4,6.84h3.58L118.23,43.38h-3.9Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.75 69.66 159.68 69.66 159.68 66.84 138.92 66.84 138.92 43.38 135.75 43.38 135.75 69.66",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,43.38h-3.16V58.86c0,6-3.87,8.77-10.34,8.77s-10.34-2.74-10.34-8.77V43.38H164V58.86c0,9.49,7.39,11.46,13.51,11.46s13.5-2,13.5-11.46Z",
    style: {
      fill: "#404041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,69.66h12C216.87,69.66,225,67,225,56.28c0-8.59-5.89-12.9-14.05-12.9H198Zm3.18-23.46H211c5.34,0,10.8,2.28,10.8,10,0,10.33-8.72,10.66-11.31,10.66h-9.3Z",
    style: {
      fill: "#404041"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 91.96,
    height: 7.2,
    style: {
      fill: "#0073ba"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.96,
    y: 10,
    width: 133.04,
    height: 7.2,
    style: {
      fill: "#e4363a"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.45,96.82H1.22L3.08,88H.5l.4-1.89H8.29L7.89,88H5.31Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14,88.63h2.2l-1,4.79a3.75,3.75,0,0,0-.12.87c0,.6.27.9.8.9a1.53,1.53,0,0,0,1.22-.84A6.92,6.92,0,0,0,13.1,92l.72-3.4H16l-1.73,8.19H12.6l.16-1.51h0A3,3,0,0,1,10.12,97a1.94,1.94,0,0,1-1.55-.61A2.52,2.52,0,0,1,8,94.62a8.5,8.5,0,0,1,.17-1.56Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.34,94.12a2.54,2.54,0,0,1-.91,2.11A3.93,3.93,0,0,1,18.9,97a7.75,7.75,0,0,1-1.37-.11,4,4,0,0,1-1.09-.37V94.68a4.67,4.67,0,0,0,2.34.66,1.75,1.75,0,0,0,1-.24.74.74,0,0,0,.1-1.21,4.92,4.92,0,0,0-1-.63,4,4,0,0,1-1.24-1,2,2,0,0,1-.35-1.16,2.38,2.38,0,0,1,.81-1.93,3.46,3.46,0,0,1,2.31-.69,5.11,5.11,0,0,1,2.66.7l-.73,1.57a3.7,3.7,0,0,0-1.89-.61,1.15,1.15,0,0,0-.67.18.59.59,0,0,0-.25.5.67.67,0,0,0,.23.51,4.69,4.69,0,0,0,.88.54,3.63,3.63,0,0,1,1.3,1A2,2,0,0,1,22.34,94.12Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.23,97a2,2,0,0,1-1.69-.78,3.45,3.45,0,0,1-.62-2.2,7.26,7.26,0,0,1,.52-2.74,5.1,5.1,0,0,1,1.38-2,2.83,2.83,0,0,1,1.89-.73,1.91,1.91,0,0,1,1,.27,2.66,2.66,0,0,1,.83.93h.06v-.2a9.12,9.12,0,0,1,.18-1.43l.56-2.62h2.2L34.17,96.82H32.49l.1-1.06h0a3.24,3.24,0,0,1-1.08.92A2.77,2.77,0,0,1,30.23,97Zm.92-1.78a1.3,1.3,0,0,0,.94-.5,3.72,3.72,0,0,0,.74-1.34,5.79,5.79,0,0,0,.28-1.79,1.44,1.44,0,0,0-.28-.94.88.88,0,0,0-.75-.35,1.27,1.27,0,0,0-.95.52,3.84,3.84,0,0,0-.71,1.4,5.65,5.65,0,0,0-.27,1.71C30.15,94.76,30.48,95.19,31.15,95.19Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.06,97a3.29,3.29,0,0,1-2.39-.83,3.13,3.13,0,0,1-.85-2.33A6.16,6.16,0,0,1,37.43,91a4.43,4.43,0,0,1,1.63-1.9,4.26,4.26,0,0,1,2.34-.66,3.1,3.1,0,0,1,2,.6,2,2,0,0,1,.72,1.63,2.36,2.36,0,0,1-1.22,2.12,6.84,6.84,0,0,1-3.49.74h-.37l0,.15v.15a1.33,1.33,0,0,0,1.46,1.44,4.53,4.53,0,0,0,1.15-.14,8.58,8.58,0,0,0,1.26-.49v1.66A6.29,6.29,0,0,1,40.06,97Zm1.2-6.9a1.7,1.7,0,0,0-1.22.59,2.75,2.75,0,0,0-.74,1.42h.33a3.59,3.59,0,0,0,1.76-.35,1.09,1.09,0,0,0,.64-1C42,90.3,41.77,90.07,41.26,90.07Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.68,88.48a2.7,2.7,0,0,1,.7.08l-.49,2.13a2.07,2.07,0,0,0-.73-.12,2,2,0,0,0-1.49.67,4,4,0,0,0-.91,1.92L47,96.82H44.78l1.74-8.19H48.2l-.15,1.52h0A3.09,3.09,0,0,1,50.68,88.48Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.71,97a3.27,3.27,0,0,1-2.38-.83,3.09,3.09,0,0,1-.85-2.33,6.29,6.29,0,0,1,.6-2.77,4.52,4.52,0,0,1,1.64-1.9,4.25,4.25,0,0,1,2.33-.66,3.06,3.06,0,0,1,2,.6,2,2,0,0,1,.73,1.63,2.36,2.36,0,0,1-1.22,2.12,6.84,6.84,0,0,1-3.49.74h-.38v.3a1.42,1.42,0,0,0,.37,1,1.46,1.46,0,0,0,1.08.39,4.61,4.61,0,0,0,1.16-.14,8.58,8.58,0,0,0,1.26-.49v1.66A6.3,6.3,0,0,1,54.71,97Zm1.2-6.9a1.7,1.7,0,0,0-1.21.59A2.84,2.84,0,0,0,54,92.08h.33a3.61,3.61,0,0,0,1.77-.35,1.08,1.08,0,0,0,.63-1C56.68,90.3,56.43,90.07,55.91,90.07Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,97a3,3,0,0,1-2.25-.79A3,3,0,0,1,59.83,94a7.09,7.09,0,0,1,.54-2.82,4.53,4.53,0,0,1,1.54-2,3.84,3.84,0,0,1,2.25-.69,5.36,5.36,0,0,1,2.4.53l-.67,1.68c-.27-.12-.52-.21-.78-.3a2.84,2.84,0,0,0-.86-.12,1.55,1.55,0,0,0-1.12.47A3.07,3.07,0,0,0,62.34,92a5.32,5.32,0,0,0-.28,1.76,1.49,1.49,0,0,0,.33,1,1.21,1.21,0,0,0,.93.36,3.13,3.13,0,0,0,1-.17,9.14,9.14,0,0,0,1-.43v1.8A5.19,5.19,0,0,1,62.87,97Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.56,96.82H71.35l1-4.78a4.3,4.3,0,0,0,.11-.87c0-.6-.26-.9-.79-.9a1.53,1.53,0,0,0-1.22.83,7.08,7.08,0,0,0-.86,2.33l-.72,3.39h-2.2l2.41-11.39H71.3l-.44,2c-.11.48-.32,1.23-.63,2.27h.06a3.92,3.92,0,0,1,1-.91,2.38,2.38,0,0,1,1.28-.34,2,2,0,0,1,1.57.61,2.57,2.57,0,0,1,.55,1.75,6.7,6.7,0,0,1-.17,1.32Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57,91.73a6.68,6.68,0,0,1-.52,2.73A3.95,3.95,0,0,1,79.25,97a2.94,2.94,0,0,1-3.13-3.15A7,7,0,0,1,76.64,91a4.26,4.26,0,0,1,1.51-1.89,4,4,0,0,1,2.31-.67,3,3,0,0,1,2.27.86A3.29,3.29,0,0,1,83.57,91.73Zm-2.22,0c0-1-.35-1.45-1-1.45a1.34,1.34,0,0,0-1,.45A3.23,3.23,0,0,0,78.61,92a6,6,0,0,0-.27,1.78c0,.9.36,1.35,1.09,1.35a1.34,1.34,0,0,0,1-.45,3,3,0,0,0,.68-1.25A5.72,5.72,0,0,0,81.35,91.73Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,94.12a2.54,2.54,0,0,1-.91,2.11,3.93,3.93,0,0,1-2.53.74,7.75,7.75,0,0,1-1.37-.11,4,4,0,0,1-1.09-.37V94.68a4.67,4.67,0,0,0,2.34.66,1.75,1.75,0,0,0,1-.24.74.74,0,0,0,.1-1.21,4.92,4.92,0,0,0-1-.63,4,4,0,0,1-1.24-1,2,2,0,0,1-.35-1.16,2.38,2.38,0,0,1,.81-1.93,3.46,3.46,0,0,1,2.31-.69,5.11,5.11,0,0,1,2.66.7l-.73,1.57a3.7,3.7,0,0,0-1.89-.61,1.15,1.15,0,0,0-.67.18.6.6,0,0,0-.26.5.68.68,0,0,0,.24.51,4.37,4.37,0,0,0,.88.54,3.63,3.63,0,0,1,1.3,1A2,2,0,0,1,90.29,94.12Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.07,95.08l.06.17a29.42,29.42,0,0,1-1.91,3.51H90.57c.36-.82.83-2,1.42-3.68Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.52,96.82h-2.2l1-4.78a3.75,3.75,0,0,0,.12-.87c0-.6-.26-.9-.79-.9a1.51,1.51,0,0,0-1.22.83,6.85,6.85,0,0,0-.87,2.33l-.71,3.39H99.64l1.74-8.19h1.68l-.15,1.52h0a3.08,3.08,0,0,1,2.6-1.67,2,2,0,0,1,1.56.61,2.52,2.52,0,0,1,.55,1.75,6,6,0,0,1-.17,1.32Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,88.63h2.2l-1,4.79a3.75,3.75,0,0,0-.12.87c0,.6.27.9.79.9a1.53,1.53,0,0,0,1.23-.84A6.92,6.92,0,0,0,114.3,92l.72-3.4h2.2l-1.73,8.19H113.8l.16-1.51h0a3.06,3.06,0,0,1-2.6,1.66,1.93,1.93,0,0,1-1.54-.61,2.52,2.52,0,0,1-.53-1.74,7.71,7.71,0,0,1,.17-1.56Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,97a3.29,3.29,0,0,1-2.39-.83,3.13,3.13,0,0,1-.85-2.33,6.29,6.29,0,0,1,.61-2.77,4.5,4.5,0,0,1,1.63-1.9,4.26,4.26,0,0,1,2.34-.66,3.1,3.1,0,0,1,2,.6,2,2,0,0,1,.72,1.63,2.36,2.36,0,0,1-1.22,2.12,6.81,6.81,0,0,1-3.49.74h-.37l0,.15v.15a1.33,1.33,0,0,0,1.46,1.44,4.53,4.53,0,0,0,1.15-.14,8.58,8.58,0,0,0,1.26-.49v1.66A6.29,6.29,0,0,1,121.37,97Zm1.2-6.9a1.7,1.7,0,0,0-1.22.59,2.75,2.75,0,0,0-.74,1.42h.33a3.59,3.59,0,0,0,1.76-.35,1.07,1.07,0,0,0,.64-1C123.34,90.3,123.08,90.07,122.57,90.07Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.89,94.12a2.54,2.54,0,0,1-.91,2.11,3.94,3.94,0,0,1-2.54.74,7.71,7.71,0,0,1-1.36-.11,4,4,0,0,1-1.09-.37V94.68a4.67,4.67,0,0,0,2.34.66,1.75,1.75,0,0,0,1-.24.76.76,0,0,0,.37-.65.73.73,0,0,0-.27-.56,4.92,4.92,0,0,0-1-.63,4,4,0,0,1-1.24-1,2,2,0,0,1-.35-1.16,2.38,2.38,0,0,1,.81-1.93,3.46,3.46,0,0,1,2.31-.69,5.11,5.11,0,0,1,2.66.7l-.73,1.57a3.7,3.7,0,0,0-1.89-.61,1.15,1.15,0,0,0-.67.18.6.6,0,0,0-.26.5.68.68,0,0,0,.24.51,4.37,4.37,0,0,0,.88.54,3.63,3.63,0,0,1,1.3,1A2,2,0,0,1,131.89,94.12Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68,95.19a3.67,3.67,0,0,0,1.18-.26v1.65a4.45,4.45,0,0,1-1.94.39,2.37,2.37,0,0,1-1.62-.46,1.85,1.85,0,0,1-.51-1.43,5.14,5.14,0,0,1,.08-.82l.85-4H133.6l.22-1.08,1.43-.61,1-1.73h1.42l-.36,1.74h2.07L139,90.31h-2.06l-.84,4a2.08,2.08,0,0,0-.05.39C136,95,136.25,95.19,136.68,95.19Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.22,88.48a2.72,2.72,0,0,1,.71.08l-.49,2.13a2.11,2.11,0,0,0-.73-.12,2,2,0,0,0-1.49.67,3.92,3.92,0,0,0-.91,1.92l-.77,3.66h-2.21l1.74-8.19h1.68l-.15,1.52h0A3.09,3.09,0,0,1,145.22,88.48Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.34,97a2,2,0,0,1-1.69-.78A3.4,3.4,0,0,1,146,94a7.18,7.18,0,0,1,.53-2.76,5,5,0,0,1,1.38-2,2.86,2.86,0,0,1,1.88-.72,2.28,2.28,0,0,1,1.22.31,2,2,0,0,1,.81.89h.05l.42-1.05H154l-1.74,8.19H150.6l.1-1.06h0A2.91,2.91,0,0,1,148.34,97Zm.86-1.78a1.35,1.35,0,0,0,1-.49,3.6,3.6,0,0,0,.75-1.33,5.88,5.88,0,0,0,.29-1.9,1.3,1.3,0,0,0-.29-.86.89.89,0,0,0-.74-.34,1.27,1.27,0,0,0-.95.52,3.84,3.84,0,0,0-.71,1.4,5.65,5.65,0,0,0-.27,1.71,1.56,1.56,0,0,0,.25,1A.82.82,0,0,0,149.2,95.19Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.12,88.48a2,2,0,0,1,1.68.79,3.43,3.43,0,0,1,.62,2.2,7.46,7.46,0,0,1-.5,2.69,5,5,0,0,1-1.37,2,2.84,2.84,0,0,1-1.92.76,1.94,1.94,0,0,1-1-.27,2.5,2.5,0,0,1-.82-.92h-.06a14,14,0,0,1-.31,2.16l-.53,2.49h-2.2l2.5-11.8h1.69l-.13,1.25h.07A2.86,2.86,0,0,1,164.12,88.48Zm-.89,1.79a1.32,1.32,0,0,0-1,.49,3.63,3.63,0,0,0-.75,1.32,5.56,5.56,0,0,0-.28,1.82,1.52,1.52,0,0,0,.27.94.9.9,0,0,0,.75.35,1.23,1.23,0,0,0,.93-.51,3.81,3.81,0,0,0,.73-1.38,5.94,5.94,0,0,0,.27-1.74Q164.19,90.27,163.23,90.27Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.25,88.48a2.64,2.64,0,0,1,.7.08l-.48,2.13a2.11,2.11,0,0,0-.73-.12,2,2,0,0,0-1.49.67,3.92,3.92,0,0,0-.91,1.92l-.78,3.66h-2.2l1.73-8.19h1.69l-.16,1.52h0A3.06,3.06,0,0,1,173.25,88.48Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87,96.82h-2.2l1.73-8.19h2.2Zm-.12-10.1a1.28,1.28,0,0,1,.35-1,1.41,1.41,0,0,1,1-.32,1.29,1.29,0,0,1,.82.22.81.81,0,0,1,.27.66,1.33,1.33,0,0,1-.32.94,1.22,1.22,0,0,1-1,.37Q175.75,87.62,175.75,86.72Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,91.73a6.85,6.85,0,0,1-.51,2.73A4.12,4.12,0,0,1,184,96.31a4,4,0,0,1-2.32.66,3,3,0,0,1-2.27-.86,3.11,3.11,0,0,1-.86-2.29A7,7,0,0,1,179,91a4.2,4.2,0,0,1,1.51-1.89,4,4,0,0,1,2.31-.67,3,3,0,0,1,2.27.86A3.32,3.32,0,0,1,186,91.73Zm-2.22,0c0-1-.34-1.45-1-1.45a1.34,1.34,0,0,0-1,.45A3.35,3.35,0,0,0,181,92a6,6,0,0,0-.27,1.78c0,.9.37,1.35,1.1,1.35a1.38,1.38,0,0,0,1-.45,3,3,0,0,0,.68-1.25A6,6,0,0,0,183.73,91.73Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.77,88.48a2.64,2.64,0,0,1,.7.08L193,90.69a2.11,2.11,0,0,0-.73-.12,2,2,0,0,0-1.49.67,3.92,3.92,0,0,0-.91,1.92l-.78,3.66h-2.2l1.74-8.19h1.68l-.16,1.52h.05A3.09,3.09,0,0,1,192.77,88.48Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.39,96.82h-2.2l1.73-8.19h2.21Zm-.12-10.1a1.28,1.28,0,0,1,.35-1,1.42,1.42,0,0,1,1-.32,1.28,1.28,0,0,1,.81.22.82.82,0,0,1,.28.66,1.33,1.33,0,0,1-.33.94,1.22,1.22,0,0,1-1,.37Q195.27,87.62,195.27,86.72Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.34,97a2.06,2.06,0,0,1-1.7-.78A3.51,3.51,0,0,1,198,94a7.26,7.26,0,0,1,.52-2.74,5.1,5.1,0,0,1,1.38-2,2.83,2.83,0,0,1,1.89-.73,1.91,1.91,0,0,1,1,.27,2.55,2.55,0,0,1,.82.93h.06l0-.2a9.12,9.12,0,0,1,.18-1.43l.56-2.62h2.2l-2.42,11.39H202.6l.1-1.06h0a3.34,3.34,0,0,1-1.08.92A2.77,2.77,0,0,1,200.34,97Zm.92-1.78a1.3,1.3,0,0,0,.94-.5,3.87,3.87,0,0,0,.74-1.34,5.78,5.78,0,0,0,.27-1.79,1.5,1.5,0,0,0-.27-.94.88.88,0,0,0-.75-.35,1.27,1.27,0,0,0-.95.52,4,4,0,0,0-.72,1.4,6,6,0,0,0-.26,1.71C200.26,94.76,200.59,95.19,201.26,95.19Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.24,97a2,2,0,0,1-1.69-.78,3.46,3.46,0,0,1-.62-2.19,7.37,7.37,0,0,1,.53-2.76,5,5,0,0,1,1.38-2,2.86,2.86,0,0,1,1.88-.72,2.34,2.34,0,0,1,1.23.31,2,2,0,0,1,.8.89h.06l.41-1.05h1.7l-1.74,8.19H211.5l.11-1.06h0A2.92,2.92,0,0,1,209.24,97Zm.87-1.78a1.34,1.34,0,0,0,1-.49,3.6,3.6,0,0,0,.75-1.33,5.88,5.88,0,0,0,.29-1.9,1.35,1.35,0,0,0-.28-.86.92.92,0,0,0-.75-.34,1.25,1.25,0,0,0-.94.52,4,4,0,0,0-.72,1.4,5.65,5.65,0,0,0-.27,1.71,1.56,1.56,0,0,0,.25,1A.83.83,0,0,0,210.11,95.19Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,97a2.06,2.06,0,0,1-1.7-.78,3.51,3.51,0,0,1-.61-2.2,7.26,7.26,0,0,1,.52-2.74,5.1,5.1,0,0,1,1.38-2,2.83,2.83,0,0,1,1.89-.73,1.91,1.91,0,0,1,1,.27,2.66,2.66,0,0,1,.83.93h0l0-.2a9.12,9.12,0,0,1,.18-1.43l.56-2.62h2.2l-2.41,11.39h-1.68l.1-1.06h0a3.34,3.34,0,0,1-1.08.92A2.77,2.77,0,0,1,218.15,97Zm.92-1.78a1.3,1.3,0,0,0,.94-.5,3.72,3.72,0,0,0,.74-1.34,5.78,5.78,0,0,0,.27-1.79,1.5,1.5,0,0,0-.27-.94.88.88,0,0,0-.75-.35,1.27,1.27,0,0,0-.95.52,4,4,0,0,0-.72,1.4,6,6,0,0,0-.26,1.71C218.07,94.76,218.4,95.19,219.07,95.19Z",
    style: {
      fill: "#666"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2021);
export default __webpack_public_path__ + "static/media/logo_2021.a240e5fbfc1dde482f5af45e42e205bf.svg";
export { ForwardRef as ReactComponent };